import Modal from "@/atomic/atoms/Modal";
import { Invoice } from "@/hooks/useTicket";
import { useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import useI18n from "@/hooks/useI18n";


const DebtContent = ({ invoice }: { invoice: Invoice | null }) => {
  const { t, Trans } = useI18n();
  
  if (!invoice) {
    return <div>{t("pages:receipt:withoutDebt")}</div>;
  }

  return (
    <div className="overflow-auto max-h-[calc(100vh-300px)] mt-6 mb-3">
    <p className="text-black text-center font-bold text-xl mb-2">{t("pages:receipt:title")}</p>
    <p className="text-black text-center text-base"><Trans i18nKey="pages:receipt:paymentSuccess" components={[<b></b>]} values={{ price: invoice?.price }} /></p>
    <p className="text-black font-bold mt-2">{t("pages:receipt:transactionData")} #{invoice?.invoiceId}</p>

   
    {invoice?.debts?.map((debt, index) => (
      <div key={index} className="w-full">
        <div className="w-full mt-1 mb-1">
          <p className="text-black font-bold mt-2">{debt.plate}</p>
          <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
          <div className="w-full flex flex-row justify-between">
            
            <p className="text-black">{debt.fmtDataTransacao}</p>
          </div>
          <div className="w-full flex flex-row justify-between">
            
            <p className="text-black">{debt.owner}</p>
          </div>
          <div className="w-full flex flex-row justify-between">
            
            <p className="text-black">{debt.nmPraca}</p>
          </div>
          <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
          <div className="w-full flex flex-row justify-between">
            <p className="text-black">{t("pages:receipt:passage")}</p>
            <p className="text-black">R$ {debt.originalPrice}</p>
          </div>
          <div className="w-full flex flex-row justify-between">
            <p className="text-black">{t("pages:receipt:fines")}</p>
            <p className="text-black">R$ {debt.fine || '0,00'}</p>
          </div>
          <div className="w-full flex flex-row justify-between">
            <p className="text-black font-bold">{t("pages:receipt:total")}</p>
            <p className="text-black font-bold">R$ {debt.price}</p>
          </div>
        </div>
        <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
      </div>
    ))}
  </div>
  )
}

const TicketModal = ({
  toggleModal,
  generatePDF,
  toggleModalRegister,
  invoice,
}: {
  toggleModal: () => void;
  toggleModalRegister?: () => void;
  generatePDF: () => void;
  invoice: Invoice | null;
}) => {
  const { t, Trans } = useI18n();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const isAuthenticated = !!customer?.client?.id;
  
  if (!isAuthenticated) {
    return (
      <Modal
        content={<div className="flex flex-col">
          <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-gray-300 rounded-full"></div>
          <button
            type="button"
            onClick={toggleModal}
            className="absolute top-6 right-6 text-black"
          >
            <img src="/svg/icon-close.svg" alt="Close" className="w-6 h-6" />
          </button>
          <DebtContent invoice={invoice} />
          
          {/* Botões específicos para recibo avulso */}
          <div className="flex flex-col gap-4">
            <button
              className="bg-white hover:bg-gray-50 text-black border border-gray-300 p-2 rounded-lg h-[calc(60px)] w-full font-medium"
              type="button"
              onClick={generatePDF}>
              {t("pages:receipt:downloadReceipt")}
            </button>
            
            <div className="text-center">
              <p className="text-black text-sm">
                <Trans i18nKey="pages:receipt:downloadReceiptDescription" components={[<b></b>]} />
              </p>
            </div>
            
            <button
              className="bg-black hover:bg-gray-800 text-white p-2 rounded-lg h-[calc(60px)] w-full font-medium opacity-40"
              type="button"
              disabled
              onClick={toggleModalRegister}>
              {t("pages:receipt:register")}
            </button>
          </div>
        </div>}
      />
    );
  }

  return (
    <Modal
      content={<div className="flex flex-col">
        <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-gray-300 rounded-full"></div>
        <button
          type="button"
          onClick={toggleModal}
          className="absolute top-6 right-6 text-black"
        >
          <img src="/svg/icon-close.svg" alt="Close" className="w-6 h-6" />
        </button>
       
        <DebtContent invoice={invoice} />
        
        <button
          className={`bg-black text-white border p-2 rounded-lg h-[calc(60px)] w-full`}
          type="button"
          onClick={generatePDF}>
          Baixar recibo
        </button>
      </div>}
    />
  );
};

export default TicketModal;
